var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongLianjie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.123 7.334L3.207 9.25a2.5 2.5 0 000 3.536v0a2.5 2.5 0 003.536 0l1.916-1.916M7.334 5.123l1.917-1.916a2.5 2.5 0 013.535 0v0a2.5 2.5 0 010 3.535L10.87 8.66M9.41 6.582L6.583 9.411",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_lianjie.535b6a39.svg";
export { SvgTongyongLianjie as ReactComponent };